import SessionManager from "../routes/SessionManager";
import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import $ from 'jquery';
import React from 'react';

let CommonUtils = {};

const config = {
    temperature: { icon: 'fa-thermometer-half', unit: '°F' },
    humidity: { icon: 'fa-tint', unit: '%' },
    co2: { icon: null, unit: 'ppm' },
    co: { icon: null, unit: 'ppm' },
    voc: { icon: null, unit: 'ppb' }
};

CommonUtils.validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
    return re.test(email);
};

CommonUtils.hasPath = (json, path) => {
    if (!json)
        return null;
    //console.log('Path -> ', path);
    let spacer = ' ';
    let p = path.split('.');
    //console.log('JObj - ', json[p[0]]);
    let k = json;
    for (let a of p) {
        if (k.hasOwnProperty(a)) {
            spacer += spacer;
            //console.log(spacer, a);
            k = k[a];
        } else {
            spacer += spacer;
            //console.log(spacer, a + ' <-- Not Found');
            return null;
        }
    }
    return (k === true || k === false) ? true : k;
};

CommonUtils.getUTCTimestampNow = () => {
    const dt = new Date();
    let secs = (dt.getHours() - dt.getUTCHours()) * 60 * 60 + (dt.getMinutes() - dt.getUTCMinutes()) * 60;
    return (dt.getTime() - secs)
}

CommonUtils.validateForm = () => {
    return new Promise((resolve, reject) => {
        $(".form-control.required:visible").each(function (ele) {
            if ($(this).hasClass('ant-select')) {
                if ($(this)[0].outerText === '') {
                    $(this).addClass("is-invalid");
                    $(this).closest("div.required").addClass("show");
                    reject(true);
                }
            } else if (!$(this).val() || $(this).val().trim().length === 0) {
                $(this).addClass("is-invalid");
                $(this).closest("div.required").addClass("show");
                reject(true);
                return;
            }
        }).promise().done(() => {
            // Even if not a mandatory, still invalid data needs correction.
            // if ($("input.is-invalid").not('.required').length > 0) {
            //   reject(true);
            // } else {
            //   resolve(true);
            // }
            resolve(true);
        });
    });
}

CommonUtils.applyDefaults = (json, path, defaults) => {
    let p = path.split('.');
    let d = JSON.parse(JSON.stringify(defaults));
    let k = json;
    for (let path of p) { // No recursive
        if (!k[path] || k[path] === undefined) {
            k[path] = d[path];
        }
        k = k[path];
        d = d[path];
    }
    for (let path of Object.keys(d)) {  // Recursive
        CommonUtils.applyDefaults(k, path, d);
    }
};

CommonUtils.hasPermission = (permission, default_permission = false) => {
    let user = (new SessionManager()).readCookie('user');
    let allowed = user && (user.user_role === 99 || (user.permissions && user.permissions.includes(permission)));
    //console.log('permission - ' + permission, allowed);
    return allowed || default_permission;
};

CommonUtils.getUnique = (arr, key) => {
    return arr.filter((l, i) => l.text && arr.findIndex(o => key ? o[key] === l[key] : o === l) === i);
};

CommonUtils.sort = (a, b, key) => {
    let x = (a[key]).toUpperCase();
    let y = (b[key]).toUpperCase();
    return ((x > y) - (y > x));
};


/**
 * Ant Table functions -- Start
 */
CommonUtils.handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    CommonUtils.state = ({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
    });
};

CommonUtils.handleReset = clearFilters => {
    clearFilters();
    CommonUtils.state = ({ searchText: '' });
};

CommonUtils.base64 = binaryData => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (loadEvent) {
            resolve(loadEvent.target.result);
        };
        reader.onerror = error => reject(error);
        reader.readAsDataURL(binaryData);
    });
};

CommonUtils.getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={node => {
                    CommonUtils.searchInput = node;
                }}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => CommonUtils.handleSearch(selectedKeys, confirm, dataIndex)}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => CommonUtils.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button onClick={() => CommonUtils.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        confirm({ closeDropdown: false });
                        CommonUtils.state = ({
                            searchText: selectedKeys[0],
                            searchedColumn: dataIndex,
                        });
                    }}
                >
                    Filter
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
        record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
    onFilterDropdownVisibleChange: visible => {
        if (visible) {
            setTimeout(() => CommonUtils.searchInput.select(), 100);
        }
    }
});

CommonUtils.validateCommaSeparatedEmails = (cs_email) => {
    let result = { found: 0, valid: [], invalid: [] };

    if (cs_email.trim().length === 0) {
        return result;
    }

    var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var emails = cs_email.split(';');

    for (let email of emails) {
        if (email && email.trim().length > 0) {
            result.found++;
            if (!email.match(mailformat)) {
                result.invalid.push(email);
            } else {
                result.valid.push(email)
            }
        }

    }

    return result;
}

CommonUtils.sendEmail = (obj) => {
    return new Promise(async function (resolve, reject) {
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/timelapse-share-video', //'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/email',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(obj)
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.generateRandom = (x, y) => {
    return Math.floor((Math.random() * y) + x);
}

CommonUtils.getDevice = async (device_id, user) => {
    let criteria = { "from": 0, "size": 1, device_id: device_id };
    return new Promise((resolve, reject) => {
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/device/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    source: 'D',
                    criteria: criteria,
                    user_type: "user",
                    user_login: user.user_login,
                    user_token: user.user_token,
                    app_name: 'SITESUPT'
                })
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data && res.data.records && res.data.records.length > 0 ? res.data.records[0] : null);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.getLocation = async (location_id, user) => {
    let criteria = { "from": 0, "size": 1, location_id: location_id, site_id: user.site_selected.site_id };
    return new Promise((resolve, reject) => {
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/location/fetch',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    source: 'D',
                    criteria: criteria,
                    user_type: "user",
                    user_login: user.user_login,
                    user_token: user.user_token,
                    app_name: 'SITESUPT'
                })
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data && res.data.records && res.data.records.length > 0 ? res.data.records[0] : null);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.getSite = async (site_id, user) => {
    let criteria = { "from": 0, "size": 1, site_id: site_id };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/site/fetch',
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({
                source: 'D',
                criteria: criteria,
                user_type: "user",
                user_login: user.user_login,
                user_token: user.user_token,
                app_name: 'SITESUPT'
            })
        }).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data && res.data.records && res.data.records.length > 0 ? res.data.records[0] : null);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.getCustomer = async (customer_id, user) => {
    let criteria = { "from": 0, "size": 1, customer_id: customer_id };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/customer/fetch',
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify({
                source: 'D',
                criteria: criteria,
                user_type: "user",
                user_login: user.user_login,
                user_token: user.user_token,
                app_name: 'SITESUPT'
            })
        }).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data && res.data.records && res.data.records.length > 0 ? res.data.records[0] : null);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.saveCustomer = async (customer_atts, user) => {

    var data = {
        user_login: user.user_login,
        user_token: user.user_token,
        form_input: {
            ...customer_atts
        }
    }

    return new Promise((resolve, reject) => {
        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/customer/modify',
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data)
        }).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(customer_atts);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.saveLocation = async (data, user) => {
    return new Promise((resolve, reject) => {
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location/modify',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify({
                    form_input: data,
                    user_type: "user",
                    user_login: user.user_login,
                    user_token: user.user_token,
                    app_name: 'SITESUPT'
                })
            }
        ).then(
            (res) => {
                if (res.status) {
                    if (res.status.code === 200)
                        resolve(res.data ? res.data.Attributes : null);
                    else
                        reject(null);
                } else {
                    reject(null);
                }
            },
            (error) => {
                reject(null);
            }
        );
    }).catch((err) => { });
}

CommonUtils.setSiteSelected = async (site) => {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');
    user.site_selected = site;
    user.zones = null;

    return new Promise((resolve, reject) => {
        var data = {
            customer_id: site.customer_id,
            site_id: site.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            async (res) => {
                if (res && res.status && res.status.code === 200) {
                    let zone_prefs = user.zone_prefs_for_sites && user.zone_prefs_for_sites[site.site_id];

                    var activeZones = (res.data).filter(zone => zone.location_adminstatus === "Up");
                    if (zone_prefs && zone_prefs.length > 0) {
                        activeZones = activeZones.sort((a, b) => {
                            return zone_prefs.indexOf(a.location_id) - zone_prefs.indexOf(b.location_id);
                        });
                    }

                    //User accessible zones only.
                    if (user.user_zones && user.user_zones[site.site_id] && user.user_zones[site.site_id].length > 0) {
                        let allowedZones = user.user_zones[site.site_id];
                        activeZones = activeZones.filter(zone => allowedZones.includes(zone.location_id));
                    }
                    user.zones = activeZones;
                } else {
                    user.zones = [];
                }

                sessionManager.storeCookie('user', user);
                resolve(user);
            },
            (error) => {
                resolve(user);
            }
        );
    }).catch((err) => {
    });
}

CommonUtils.applySiteDefaults = async (site) => {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');

    return new Promise((resolve, reject) => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token
        }
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            async (res) => {
                if (res && res.status && res.status.code === 200) {

                }
                resolve(user);
            },
            (error) => {
                resolve(user);
            }
        );
    }).catch((err) => {
    });
}

CommonUtils.formatSensorData = (param, value) => {
    const isValid = v => v !== undefined && v !== null && v !== '' && v !== '-100' && v !== -100;
    if (!isValid(value) || !config[param]) return '';

    const { icon, unit } = config[param];
    return (
        <>
            {icon && <i className={`fa ${icon}`}></i>} {value} {unit}
        </>
    );
}

/**
 * Ant Table functions -- End
 */

export default CommonUtils;
